import type { SVGProps } from "react";
import styles from "./Icone.module.scss";
import { Adatta, Immagine, NomeIcona } from "./types";
// import type { Immagine, NomeIcona } from "../../types/content";

const base: SVGProps<SVGSVGElement> = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

interface IconaProps {
  nome: NomeIcona;
  size?: number;
}

export function Icona({ nome, size = 34 }: IconaProps) {
  const p: SVGProps<SVGSVGElement> = {
    ...base,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: 1.6,
  };
  switch (nome) {
    case "reel":
      return (
        <svg {...p}>
          <rect x="6" y="2" width="12" height="20" rx="3" />
          <path d="M10.5 9.5v5l4-2.5z" />
        </svg>
      );
    case "calendario":
      return (
        <svg {...p}>
          <rect x="3" y="4" width="18" height="17" rx="3" />
          <path d="M3 9h18M8 2v4M16 2v4M7.5 13h3M13.5 13h3M7.5 17h3" />
        </svg>
      );
    case "target":
      return (
        <svg {...p}>
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="12" cy="12" r="1.2" />
        </svg>
      );
    case "web":
      return (
        <svg {...p}>
          <rect x="2" y="4" width="20" height="14" rx="2" />
          <path d="M8 22h8M12 18v4M9 9l-2 2 2 2M15 9l2 2-2 2" />
        </svg>
      );
    default:
      return null;
  }
}

export function Freccia() {
  return (
    <svg {...base} width={18} height={18} viewBox="0 0 24 24" strokeWidth={2}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

/** Unisce più classi ignorando quelle vuote */
export const cx = (...classi: (string | false | null | undefined)[]) =>
  classi.filter(Boolean).join(" ");

interface MediaProps {
  src: Immagine;
  alt?: string;
  segnaposto: string;
  className?: string;
  adatta?: Adatta;
}

/** Mostra la foto se c'è, altrimenti un riquadro segnaposto */
export function Media({ src, alt = "", segnaposto, className, adatta = "riempi" }: MediaProps) {
  if (src)
    return (
      <img
        className={cx(styles["media"], adatta === "intera" && styles["media--intera"], className)}
        src={src}
        alt={alt}
        loading="lazy"
      />
    );
  return (
    <div className={cx(styles["media"], styles["media--vuoto"], className)} aria-hidden="true">
      [{segnaposto}]
    </div>
  );
}
